"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _resolveImage = _interopRequireDefault(require("../../utils/resolveImage"));
var _image = _interopRequireDefault(require("../../helper/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _core.makeStyles)(theme => ({
  root: {
    background: theme.palette.primary.main,
    display: "flex",
    flexDirection: "column",
    minHeight: "100%"
  },
  link: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100%"
  },
  imageDiv: {
    paddingTop: "79.834%",
    position: "relative"
  },
  content: {
    bottom: 0,
    left: 0,
    position: "absolute",
    right: 0,
    top: 0
  },
  title: {
    alignItems: "center",
    color: theme.palette.common.white,
    display: "flex",
    flex: 1,
    fontSize: "clamp(18px, 5vw, 28px)",
    hyphens: "auto",
    justifyContent: "center",
    overflow: "hidden",
    padding: theme.spacing(2),
    textAlign: "center",
    textOverflow: "ellipsis"
  }
}));
const TeaserGridItem = props => {
  const {
    link,
    media,
    mediaFormat,
    title,
    skeleton
  } = props;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.root, "teaser-grid-item")
  }, /*#__PURE__*/_react.default.createElement(DetectLink, {
    link: link
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.imageDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.content
  }, /*#__PURE__*/_react.default.createElement(TeaserGridItemImage, {
    media: (0, _lodash.first)(media),
    mediaFormat: mediaFormat,
    skeleton: skeleton
  }))), title && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.title,
    variant: "h2",
    component: "p",
    dangerouslySetInnerHTML: {
      __html: title
    }
  })));
};
const DetectLink = _ref => {
  let {
    children,
    link
  } = _ref;
  const css = useStyles();
  const external = link.indexOf("http://") > -1 || link.indexOf("https://") > -1;
  if (external) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: css.link,
      href: link,
      target: "_blank",
      rel: "noreferrer"
    }, children);
  } else {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: css.link,
      to: link
    }, children);
  }
};
const TeaserGridItemImage = props => {
  var _subFormat, _subFormat2, _subFormat3, _subFormat4, _subFormat5;
  const {
    media,
    mediaFormat = "teaser-slider"
  } = props;
  const {
    REACT_APP_PATH
  } = process.env;
  let subFormat = null;
  if (media !== null && media !== void 0 && media.subFormats) {
    subFormat = (0, _lodash.first)((0, _resolveImage.default)(media === null || media === void 0 ? void 0 : media.subFormats, mediaFormat));
  }
  if (!subFormat) {
    console.warn("teaser-grid-item: fallback main format (format teaser-grid not found)");
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_image.default, {
    filename: ((_subFormat = subFormat) === null || _subFormat === void 0 ? void 0 : _subFormat.filename) && (((_subFormat2 = subFormat) === null || _subFormat2 === void 0 ? void 0 : _subFormat2.filename.charAt(0)) === "/" ? REACT_APP_PATH : "") + ((_subFormat3 = subFormat) === null || _subFormat3 === void 0 ? void 0 : _subFormat3.filename),
    height: (_subFormat4 = subFormat) === null || _subFormat4 === void 0 ? void 0 : _subFormat4.height,
    width: (_subFormat5 = subFormat) === null || _subFormat5 === void 0 ? void 0 : _subFormat5.width,
    alt: media === null || media === void 0 ? void 0 : media.alt
  }));
};
var _default = exports.default = TeaserGridItem;